module.exports = __webpack_public_path__ + "static/lobby-d5aa770e2758db40d6783f492b26c0b9.jpg";